import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Box, Typography } from '@mui/material';

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  console.log('location', location);

  return (
    <>
      <Box
        className={location.pathname === '/in/selfregistration' ? 'footerBoxBig' : 'footerBox'}
      />
      <Box className="footerLinkBox">
        {location.pathname === '/in/selfregistration' ? (
          <>
            <Box mb={1}>
              <Link to="/in/faq" className="footerLink">
                {t('FAQ')}
              </Link>
              <Typography variant="caption">|</Typography>
              <Link to="/in/contact" className="footerLink">
                {t('Contact us')}
              </Link>
            </Box>
            <Typography variant="body2" className="footerCopyRightBox">
              {/* Copyright © 2024 Kalolytic. All Rights Reserved */}
              Powered by Kalolytic
            </Typography>
          </>
        ) : (
          <Typography variant="body2" className="footerCopyRightBox">
            {/* Copyright © 2024 Kalolytic. All Rights Reserved */}
            Powered by{' '}
            {/* <a
              style={{ fontSize: '0.75rem', color: '#111B53' }}
              href="https://kalolytic.com/"
              target="_blank"
            > */}
            Kalolytic
            {/* </a> */}
          </Typography>
        )}
      </Box>
    </>
  );
};

export default Footer;
